import { memo, SVGProps } from 'react';

import NetworkOffline from './NetworkOffline.svg';
import Clock from './Clock.svg';
import ClockLightning from './ClockLightning.svg';

const icons = {
  networkOffline: NetworkOffline,
  clock: Clock,
  clockLightning: ClockLightning,
} as const;

interface SignalIconProps extends SVGProps<SVGSVGElement> {
  name: keyof typeof icons | (string & {}); // string & {} is a workaround for TS to accept any string but show intellisense for known keys
}

const SignalIcon = ({ name, ...rest }: SignalIconProps) => {
  const Icon = icons[name as keyof typeof icons];
  if (!Icon) return null;
  return <Icon {...rest} />;
};

export default memo(SignalIcon);
